function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function _404() {
  return import(/* webpackChunkName: "page-404" */ '@/pages/404.vue')
}
function _8views() {
  return import(/* webpackChunkName: "page-8views" */ '@/pages/8views.vue')
}
function awards() {
  return import(/* webpackChunkName: "page-awards" */ '@/pages/awards.vue')
}
function contact() {
  return import(/* webpackChunkName: "page-contact" */ '@/pages/contact.vue')
}
function enjoy() {
  return import(/* webpackChunkName: "page-enjoy" */ '@/pages/enjoy.vue')
}
function history() {
  return import(/* webpackChunkName: "page-history" */ '@/pages/history.vue')
}
function intro() {
  return import(/* webpackChunkName: "page-intro" */ '@/pages/intro.vue')
}
function kimcLT() {
  return import(/* webpackChunkName: "page-kimcLT" */ '@/pages/kimcLT.vue')
}
function kimcWL() {
  return import(/* webpackChunkName: "page-kimcWL" */ '@/pages/kimcWL.vue')
}
function outstanding() {
  return import(
    /* webpackChunkName: "page-outstanding" */ '@/pages/outstanding.vue'
  )
}
function scene() {
  return import(/* webpackChunkName: "page-scene" */ '@/pages/scene.vue')
}
function sponsor() {
  return import(/* webpackChunkName: "page-sponsor" */ '@/pages/sponsor.vue')
}
function test() {
  return import(/* webpackChunkName: "page-test" */ '@/pages/test.vue')
}
function tourist_guide() {
  return import(
    /* webpackChunkName: "page-tourist-guide" */ '@/pages/tourist-guide.vue'
  )
}
function traffic4_0() {
  return import(
    /* webpackChunkName: "page-traffic4.0" */ '@/pages/traffic4.0.vue'
  )
}
function vote() {
  return import(/* webpackChunkName: "page-vote" */ '@/pages/vote.vue')
}
function winner_list() {
  return import(
    /* webpackChunkName: "page-winner-list" */ '@/pages/winner-list.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: '404',
    path: '404',
    component: _404,
  },
  {
    name: '8views',
    path: '8views',
    component: _8views,
  },
  {
    name: 'awards',
    path: 'awards',
    component: awards,
  },
  {
    name: 'contact',
    path: 'contact',
    component: contact,
  },
  {
    name: 'enjoy',
    path: 'enjoy',
    component: enjoy,
  },
  {
    name: 'history',
    path: 'history',
    component: history,
  },
  {
    name: 'intro',
    path: 'intro',
    component: intro,
  },
  {
    name: 'kimcLT',
    path: 'kimcLT',
    component: kimcLT,
  },
  {
    name: 'kimcWL',
    path: 'kimcWL',
    component: kimcWL,
  },
  {
    name: 'outstanding',
    path: 'outstanding',
    component: outstanding,
  },
  {
    name: 'scene',
    path: 'scene',
    component: scene,
  },
  {
    name: 'sponsor',
    path: 'sponsor',
    component: sponsor,
  },
  {
    name: 'test',
    path: 'test',
    component: test,
  },
  {
    name: 'tourist-guide',
    path: 'tourist-guide',
    component: tourist_guide,
  },
  {
    name: 'traffic4.0',
    path: 'traffic4.0',
    component: traffic4_0,
  },
  {
    name: 'vote',
    path: 'vote',
    component: vote,
  },
  {
    name: 'winner-list',
    path: 'winner-list',
    component: winner_list,
  },
]
